export default "/images/Mobiles.webp?e21f7b90aa536b47a71d9faa0bc7460c";